import { render } from "./Colors.vue?vue&type=template&id=7d237fd4"
import script from "./Colors.vue?vue&type=script&lang=ts"
export * from "./Colors.vue?vue&type=script&lang=ts"
script.render = render

export default script